import { useTranslation } from 'react-i18next'
import { AiButton } from '@/components/ui/ai-button'

/**
 * The schema agent's entry point in the editor toolbar. It wears the app's aurora
 * AI treatment, the one "Ask Xendrel" and the empty state's agent CTA use, so it
 * stands apart from the copper editing actions beside it.
 */
export function SchemaAgentButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation()
  return (
    <AiButton emphasis="neon" size="default" onClick={onClick} className="max-md:w-full">
      {t('schemaAgent.action')}
      <span className="ml-2 rounded-md bg-primary-foreground/20 px-1.5 py-0.5 align-middle text-3xs font-semibold ring-1 ring-primary-foreground/25">
        {t('schemaAgent.intro.new')}
      </span>
    </AiButton>
  )
}
